import {
    getFirstLegalSignalComment,
    getLegalSignalCommentTarget,
    hasCommentLegalSignals,
} from "../comments/legalSignals";

export const createReviewMobileAutoOpenState = (analysisKey = null) => ({
    analysisKey,
    commentsOpened: false,
    signalsOpened: false,
    userDismissed: false,
    dismissedPanels: {
        comments: false,
    },
});

export const getReviewMobileAutoOpenAnalysisKey = ({
    reviewId,
    currentVersionId,
    documentVersionId,
    contentId,
} = {}) => [
    reviewId || "review",
    currentVersionId || documentVersionId || contentId || "version",
].join(":");

export const markReviewMobileAutoOpenDismissed = (autoState, panel = null) => {
    if (!autoState || typeof autoState !== "object") return autoState;
    autoState.userDismissed = true;
    if (!autoState.dismissedPanels) {
        autoState.dismissedPanels = { comments: false };
    }
    if (panel === "comments") {
        autoState.dismissedPanels[panel] = true;
    }
    return autoState;
};

export const markReviewMobileLaunchOpenedComments = (autoState) => {
    if (!autoState || typeof autoState !== "object") return autoState;
    autoState.commentsOpened = true;
    return autoState;
};

export const hasReviewMobileLegalSignals = hasCommentLegalSignals;
export const getFirstReviewMobileLegalSignalComment = getFirstLegalSignalComment;
export const getReviewMobileCommentTarget = getLegalSignalCommentTarget;

export const computeReviewMobileAutoOpenActions = ({
    enabled = false,
    isCreate = false,
    autoState = {},
    comments = [],
} = {}) => {
    const state = autoState || {};
    if (!enabled || isCreate || state.userDismissed) return [];

    const normalizedComments = Array.isArray(comments) ? comments : [];
    const firstSignalComment = getFirstReviewMobileLegalSignalComment(normalizedComments);

    if (firstSignalComment && !state.signalsOpened) {
        return [{
            type: "open_comments",
            reason: "first_signal",
            comment: firstSignalComment,
            focusSignal: true,
        }];
    }

    if (normalizedComments.length > 0 && !state.commentsOpened) {
        return [{
            type: "open_comments",
            reason: "first_comment",
            comment: normalizedComments[0],
            focusSignal: false,
        }];
    }

    return [];
};
